import { PageLoader } from '@/components/ui/Spinner';

export function CallbackPage() {
  // AuthContext handles the OAuth callback and redirects
  // This page just shows a loading state
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center">
        <PageLoader />
        <p className="mt-4 text-gray-400">
          Signing you in...
        </p>
      </div>
    </div>
  );
}
